import { Box } from "@mui/material";

import SquareChip from "@/components/elements/Chips/SquareChip";
import { ListCard } from "@/components/Luna/features";
import useLesson from "@/contexts/useLesson";
import type { Example } from "@/types";
import { htmlContentStyles } from "@/utils/htmlContentStyle";
import { renderMathInHtml } from "@/utils/mathRenderer";

interface ExampleItemProps {
  example: Example;
  index: number;
  onOpenModal: (index: number) => void;
  isFocused: boolean;
}

const ExampleItem = ({
  example,
  index,
  onOpenModal,
  isFocused,
}: ExampleItemProps) => {
  const { lessonResourceState } = useLesson();
  const isRead = lessonResourceState?.readItems?.includes(example.id);

  return (
    <ListCard
      id={example.id}
      title={`Example ${index + 1}`}
      index={index}
      isApproved={example.isApproved}
      onApprove={() => { }}
      onRegenerate={() => { }}
      onDelete={() => { }}
      onOpenModal={() => onOpenModal(index)}
      isRead={isRead}
      isFocused={isFocused}
      appearance="example"
      viewMoreLabel="View example"
    >
      <SquareChip
        label={example.concept}
        sx={{
          mb: 1,
          py: 0,
          px: 0.5,
          borderRadius: 1,
          border: "none",
          backgroundColor: "background.paper",
          color: "text.primary",
          fontWeight: 500,
          textTransform: "none",
          letterSpacing: 0,
        }}
      />

      <Box
        component="div"
        sx={{
          cursor: "pointer",
          "& *": {
            margin: 0,
            padding: 0,
          },
          "& p:last-child": {
            marginBottom: 0,
          },
          ...htmlContentStyles,
        }}
        onClick={(e) => {
          e.stopPropagation();
          onOpenModal(index);
        }}
        dangerouslySetInnerHTML={{
          __html: renderMathInHtml(example.description),
        }}
      />
    </ListCard>
  );
};

export default ExampleItem;
